// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Jz3Jg","colBig":"styles_colBig__1dSkC","colSmall":"styles_colSmall__3_Pzh"};